import React, { Component } from "react";
import './HomeBanner.css';
import { Typography, Button } from 'antd';
import { Link } from "react-router-dom";

const { Title, Paragraph } = Typography;

class HomeBanner extends Component<any, any> {
    private readonly initState!: any;

    constructor(props: any) {
        super(props);

        this.initState = {
            loading: false,
        }
        this.state = { ...this.initState }
    }

    render() {
        return (
            <React.Fragment>
                <div style={{
                    backgroundImage: `url('${this.props.backgroundImage}')`,
                    backgroundAttachment: `${this.props.backgroundAttachment}`,
                    position: 'relative',
                }} className={this.props.imageCode}>
                    <div className="banner-content" style={{
                        position: 'absolute',
                        top: this.props.isDesktop ? '70%' : '50%',
                        left: '2%',
                        transform: 'translateY(-50%)',
                        color: '#fff',
                        maxWidth: '600px',
                        padding: '10px',
                        background: 'linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.4), rgba(0,0,0,0))',
                        borderRadius: '8px'
                    }}>
                        <div style={{ padding: '10px' }}>
                            <Title level={1} style={{
                                color: '#fff',
                                fontSize: this.props.isDesktop ? '44px' : '20px',
                                marginBottom: '16px',
                                fontWeight: 'bold',
                                textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                            }}>
                                VF 3
                            </Title>
                            <Paragraph style={{
                                color: '#fff',
                                fontSize: this.props.isDesktop ? '18px' : '16px',
                                marginBottom: '16px',
                                lineHeight: '1.6',
                                textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
                            }}>
                                Meet the all-electric VinFast VF 3, establishing a fun, playful approach to electric mobility among micro-SUVs for you to be set apart to express your unique life adventures.
                            </Paragraph>
                            <Link to={`variant/VF3_4X2_AT_WI_BAT`}>
                                <Button type="primary" size="large" style={{
                                    height: '40px',
                                    padding: '0 10px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    border: 'none',
                                    background: '#1890ff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}>
                                    Lihat Variant
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default HomeBanner;
